import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
    selector: "crew-multiselect-buttons",
    template: require('./multiselect-buttons.component.html'),
    styles: [":host { min-width: 100px; }"]
})
export class MultiselectButtonsComponent {
    @Input()
    hasAvailableItems: boolean;

    @Input()
    hasMarkedAvailableItems: boolean;

    @Input()
    hasMarkedSelectedItems: boolean;

    @Input()
    hasSelectedItems: boolean;

    @Output()
    onAddAllItems = new EventEmitter<void>();

    @Output()
    onAddMarkedItems = new EventEmitter<void>();

    @Output()
    onRemoveMarkedItems = new EventEmitter<void>();

    @Output()
    onRemoveAllItems = new EventEmitter<void>();

    addAllItems(): void {
        this.onAddAllItems.emit();
    }

    addMarkedItems(): void {
        this.onAddMarkedItems.emit();
    }

    removeMarkedItems(): void {
        this.onRemoveMarkedItems.emit();
    }

    removeAllItems(): void {
        this.onRemoveAllItems.emit();
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/components/multiselect-buttons.component.ts